import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { VaultStorageService } from './vault-store-service';
import { VaultTokenRefreshService } from './vault-token-refresh.service';
import { Observable } from 'rxjs';

type VaultUserData = Record<string, unknown> | null;

@Injectable({ providedIn: 'root' })
export class VaultAuthService {
  private readonly authService = inject(AuthService);
  private readonly vaultStorage = inject(VaultStorageService);
  private readonly vaultTokenRefresh = inject(VaultTokenRefreshService);

  private isAutoRefreshing = false;

  isAuthenticated(): boolean {
    return this.vaultStorage.isTokenValid();
  }

  getAccessToken(): string | null {
    const token = this.vaultStorage.getAccessToken();
    const remainingTime = this.vaultStorage.getTokenRemainingTime();

    if (token && remainingTime && remainingTime < 300000 && !this.isAutoRefreshing) {
      this.refreshTokenAutomatically();
    }

    return token;
  }

  getRefreshToken(): string | null {
    return this.vaultStorage.getRefreshToken();
  }

  getUserData(): VaultUserData {
    return this.vaultStorage.getUserData();
  }

  private refreshTokenAutomatically(): void {
    this.isAutoRefreshing = true;

    this.vaultTokenRefresh.refreshToken().subscribe({
      next: () => {
        this.isAutoRefreshing = false;
      },
      error: () => {
        this.isAutoRefreshing = false;
      },
    });
  }

  forceRefreshToken(): Observable<string> {
    return this.vaultTokenRefresh.refreshToken();
  }

  logout(): void {
    this.authService.logout();
  }
}
